import { create } from "zustand";

let idc = 0;
export const useToasts = create((set, get) => ({
  toasts: [],
  push: (msg, tone = "ok", opts = {}) => {
    const id = ++idc;
    const duration = opts.duration ?? 3200;
    const action = opts.action || null; // { label, onClick }
    set((s) => ({ toasts: [...s.toasts, { id, msg, tone, action }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, duration);
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export default function Toasts() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.tone}`} data-testid={`toast-${t.tone}`}>
          <span>{t.msg}</span>
          {t.action ? (
            <button
              className="btn small"
              onClick={() => { t.action.onClick(); dismiss(t.id); }}
              data-testid="toast-action"
              style={{ marginLeft: 10 }}
            >
              {t.action.label}
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
